import ApplicationSerializer from './application';

export default class VisitorSurveyConfigurationSerializer extends ApplicationSerializer {
  attrs = {
    contacts: { serialize: false },
  };
}
